import { get, internalDestroy, internalPost, internalPut } from '.';
import qs from 'qs';

export const getThemes = ({ filters }) => {
  return get(`/themes?${qs.stringify(filters)}`);
};

export const getTheme = ({ themeId, locale }) => {
  return get(`/themes/${themeId}?locale=${locale}`);
};

export const createTheme = ({ payload, locale }) => {
  return internalPost(`/themes?locale=${locale}`, payload);
};

export const updateTheme = ({ themeId, payload, locale }) => {
  return internalPut(`/themes/${themeId}?locale=${locale}`, payload);
};

export const deleteTheme = ({ themeId, payload }) => {
  return internalDestroy(`/themes/${themeId}`, payload);
};
